export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref10832.6af11723.jpg";